export default "__VITE_ASSET__7fc9ffc7__"